import store from "@/store"
import ajax from "@/server/ajax"
export const supplierRuleCategory = (data) => {
  return ajax({
    url: `supplier.rule/category`,
    method: "GET",
    params: data
  })
}
export const supplierRuleList = (data) => {
  return ajax({
    url: `supplier.rule/list`,
    method: "GET",
    params: data
  })
}
export const supplierRuleDetail = (data) => {
  return ajax({
    url: `supplier.rule/detail`,
    method: "GET",
    params: data
  })
}

